module.exports = __webpack_public_path__ + "static/media/user-ninja.ba7ec1d5.svg";